var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrap"},[(_vm.loading)?[(_vm.loadName==='dotLoading')?_c('div',{staticClass:"loading dotLoading",style:(`color:${_vm.color};`)},[_c('div'),_c('div'),_c('div')]):_vm._e()]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }